// src/pages/menu/LoungeTablesAndOrdersDashboard.jsx
import React from 'react';
import LocationTablesAndOrdersDashboard from '../TablesAndOrdersDashboard';

const LoungeTablesAndOrdersDashboard = () => {
  return <LocationTablesAndOrdersDashboard locationKey="lounge" />;
};

export default LoungeTablesAndOrdersDashboard;